export const OFFERS = [
  {
    id: "diagnostic-agile",
    code: "DA",
    title: "Diagnostic Agile",
    tagline: "Un regard expert pour révéler la maturité agile réelle de votre organisation.",
    description:
      "Une évaluation externe, experte et pragmatique de la façon dont votre organisation met en œuvre l'agilité. Forces, faiblesses, axes d'amélioration : un plan d'action priorisé pour optimiser performance, collaboration et autonomie des équipes.",
    objectifs: [
      "Challenger les pratiques agiles existantes pour gagner en maturité",
      "Identifier les freins qui ralentissent la transformation",
      "Obtenir une vision claire des forces, faiblesses et axes de progrès",
      "Définir une feuille de route concrète",
      "Préparer une transformation ou un changement d'échelle",
    ],
    deroulement: [
      "Préparation : cadrage avec le sponsor, définition du périmètre, collecte de données",
      "Diagnostic terrain : interviews, ateliers, observation des rituels, analyse des indicateurs — sur 5 dimensions (leadership, gouvernance, collaboration, excellence technique, valeur)",
      "Analyse & restitution : synthèse, recommandations, rapport complet et visuel",
    ],
    livrables: [
      "Radar de maturité et cartographie forces / faiblesses",
      "Top 10 des priorités et Quick Wins",
      "Roadmap des recommandations, vision à 6 mois",
      "Rapport d'audit et résumé exécutif",
    ],
    formules: [
      { nom: "Audit Agile Flash", duree: "2 jours" },
      { nom: "Diagnostic Agile 360°", duree: "3 à 4 jours" },
      { nom: "Diagnostic à l'échelle", duree: "5 à 8 jours" },
    ],
    cibles: ["DSI", "Directeur Produit", "Directeur de la Transformation", "Coach Agile", "Responsable Méthodes & Outils"],
  },
  {
    id: "amelioration-processus",
    code: "CAP",
    title: "Conseil en Amélioration des Processus",
    tagline: "Analyser, modéliser, optimiser et piloter vos processus pour une performance durable.",
    description:
      "Nous aidons les organisations à analyser, modéliser, optimiser et piloter leurs processus métier pour améliorer durablement leur performance opérationnelle — directions métiers, DSI, ingénierie, qualité, transformation.",
    objectifs: [
      "Résoudre les dysfonctionnements : pratiques hétérogènes, interfaces complexes, documentation faible",
      "Remédier aux problèmes récurrents et retards systématiques",
      "Formaliser les processus, clarifier les responsabilités, éliminer les redondances",
      "Mettre en place des indicateurs de pilotage",
    ],
    deroulement: [
      "Audit des processus : cartographie, analyse des dysfonctionnements, diagnostic de maturité, gap analysis",
      "Recommandations fondées sur les bonnes pratiques et l'état de l'art",
      "Optimisation : simplification, réduction des délais et coûts, standardisation, apport de l'IA",
      "Conception de nouveaux processus : RACI, SIPOC, Value Stream Mapping",
      "Modélisation : BPMN, UML",
    ],
    livrables: [
      "Rapport d'audit avec recommandations",
      "Cartographie des processus et chaîne de valeur",
      "Modèles BPMN, tableau RACI, tableau de bord d'indicateurs",
      "Feuille de route de transformation",
    ],
    formules: [
      { nom: "Diagnostic Flash", duree: "2 jours" },
      { nom: "Diagnostic 360°", duree: "5 à 6 jours" },
      { nom: "Optimisation ciblée", duree: "5 à 15 jours" },
      { nom: "Transformation des processus", duree: "Sur mesure" },
    ],
    cibles: ["DSI", "Manager de SI", "Responsable Métier", "Directeur de la Transformation", "Responsable Processus & Méthodes"],
  },
  {
    id: "ingenierie-exigences",
    code: "CIE",
    title: "Conseil en Ingénierie des Exigences",
    tagline: "Un référentiel d'exigences tracé, maîtrisé, garant de la satisfaction du besoin.",
    description:
      "Pour les organisations qui conçoivent des systèmes complexes et des systèmes d'information : établir et maintenir un référentiel d'exigences qui trace le besoin tout au long du cycle de vie — de la définition à la maintenance.",
    objectifs: [
      "Éliminer les cahiers des charges incomplets ou ambigus",
      "Maîtriser la traçabilité et les évolutions d'exigences",
      "Réduire les incompréhensions entre métiers et équipes techniques",
      "Satisfaire les exigences réglementaires (ISO, DO-178, IEC 62304, ASPICE…)",
    ],
    deroulement: [
      "Audit : analyse, diagnostic, évaluation de maturité",
      "Mise en œuvre d'une démarche d'ingénierie des exigences",
      "Aide à la rédaction des cahiers des charges et expressions de besoin",
      "Aide au choix d'outils : critères, dépouillement, Proof of Concept",
    ],
    livrables: [
      "Référentiel d'exigences et plan de gestion",
      "Guide de rédaction des exigences",
      "Matrice de traçabilité",
      "Évaluation de maturité et recommandations outils",
    ],
    formules: [
      { nom: "Diagnostic Express", duree: "2 jours" },
      { nom: "Diagnostic Complet", duree: "5 jours" },
      { nom: "Accompagnement / Coaching", duree: "Sur mesure" },
    ],
    cibles: ["DSI", "Manager de SI", "Directeur de l'Ingénierie", "Responsable R&D"],
    secteurs: "Défense · Aéronautique · Ferroviaire · Automobile · Médical · Énergie · Télécoms · SI complexes",
  },
  {
    id: "referentiels-conformite",
    code: "CIRC",
    title: "Conseil en Ingénierie des Référentiels de Conformité",
    tagline: "Transformer les réglementations et les normes en exigences exploitables et traçables.",
    description:
      "Pour les organisations qui doivent maîtriser un patrimoine d'exigences réglementaires, normatives ou contractuelles : construire un référentiel unique, traçable, maintenable et partagé par l'ensemble des projets.",
    objectifs: [
      "Comprendre quelles exigences s'appliquent réellement à un produit",
      "Démontrer et maintenir la conformité aux dernières réglementations",
      "Retrouver rapidement l'obligation concernée",
      "Partager le patrimoine d'exigences entre projets",
    ],
    deroulement: [
      "Audit du patrimoine réglementaire et normatif",
      "Construction du référentiel de conformité",
      "Mise en place de la gouvernance et de la veille réglementaire",
      "Aide au choix d'outils d'ingénierie",
    ],
    livrables: [
      "Cartographie réglementaire et taxonomie des exigences",
      "Matrice de conformité",
      "Processus de gestion, workflow et tableau de bord",
      "Processus de veille réglementaire",
    ],
    formules: [
      { nom: "Diagnostic Express", duree: "2 jours" },
      { nom: "Diagnostic Complet", duree: "5 à 6 jours" },
      { nom: "Accompagnement / Coaching", duree: "Sur mesure" },
    ],
    cibles: ["DSI", "Responsable Référentiels", "Responsable Gouvernance SI", "RSSI", "Responsable Qualité & Conformité"],
  },
  {
    id: "formations",
    code: "FOR",
    title: "Formations",
    tagline: "Investir dans les compétences, c'est investir durablement dans la performance.",
    description:
      "Des formations pragmatiques et opérationnelles, fondées sur des retours d'expérience réels, dispensées par les experts ReqEn Consulting et ASAP Technologies. En présentiel ou à distance, en inter ou intra-entreprise.",
    objectifs: [
      "Montée en compétence rapide des équipes",
      "Partage d'un vocabulaire commun et harmonisation des pratiques",
      "Meilleure collaboration entre métiers et IT",
      "Sécuriser les projets et accélérer la transformation",
    ],
    catalogue: [
      { domaine: "Ingénierie des Exigences", items: ["Fondamentaux (1 à 3 j)", "Certification IREB (3 j)", "Améliorer l'énoncé des exigences (1 j)", "Soft Skills (2-3 j)", "Exigences en contexte agile (2 j)"] },
      { domaine: "Ingénierie Système", items: ["Sensibilisation à l'ingénierie système (1 j)"] },
      { domaine: "Business Analyse", items: ["Les Fondamentaux (2 j)", "Certification IQBBA (3 j)", "Agile Business Analyste (2-3 j)"] },
      { domaine: "Agilité", items: ["Méthodes de gestion de projets agiles (2 j)", "Scrum Master (2 j)", "Product Owner / Product Manager (2 j)"] },
      { domaine: "Agilité à l'échelle", items: ["Leading SAFe® (2 j)", "SAFe® for Teams (2 j)"] },
    ],
    certifications: ["IREB", "IQBBA", "SAFe®"],
    cibles: ["Ingénieurs systèmes", "Requirements Managers", "Product Owners", "Business Analysts", "Scrum Masters", "Chefs de projet"],
  },
];
